import Loadable from 'react/components/loadable';

const RefreshCachedDashletDataModal = Loadable({
  loader: () => import('../../pages/dashboard/components/refresh_cached_dashlet_data_modal'),
  type: 'modal',
});

angular.module('gym').value('RefreshCachedDashletDataModal', RefreshCachedDashletDataModal);
